import { Fragment, useState, useEffect, useCallback } from "react";
import AddYoutube from "./components/AddYoutube";
import Video from "./components/UI/Video";
import Spinner from "./components/UI/Spinner";
import YoutubeList from "./components/YoutubeList";
import "./App.css";

function App() {
  const [movies, setMovies] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchMoviesHandler = useCallback(async () => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await fetch(
        "https://www.marchouben.nl/php/youtube-get.php"
      );

      console.log(response);

      if (!response.ok) {
        console.log(response.status);
        throw new Error("Something went wrong: " + response.status);
      }

      const data = await response.json();
      console.log(data);
      setMovies(data);
    } catch (error) {
      console.log(error.message);
      setError(error.message);
    }
    setIsLoading(false);
  }, []);

  useEffect(() => {
    fetchMoviesHandler();
  }, [fetchMoviesHandler]);

  async function addMovieHandler(movie) {
    console.log(movie);

    // Dit werkt alleen als "movie" ook key en id bevat
    //let updatedMovies = [...movies, movie];
    //console.log(updatedMovies);
    //setMovies(updatedMovies);

    const response = await fetch(
      "https://www.marchouben.nl/php/youtube-post.php",
      {
        method: "POST",
        body: JSON.stringify(movie),
        headers: {
          "Content-Type": "text/plain",
        },
      }
    );
    const data = await response.json();
    console.log(data);
  }

  let content = <p>Geen video's beschikbaar</p>;

  if (movies.length > 0) {
    content = <YoutubeList movies={movies} />;
  }

  if (error) {
    content = <p>{error}</p>;
  }

  if (isLoading) {
    content = <Spinner />;
  }

  return (
    <Fragment>
      <section>
        <AddYoutube onAddMovie={addMovieHandler} />
      </section>
      <section>
        <button onClick={fetchMoviesHandler}>Video's Tonen</button>
      </section>
      <section>{content}</section>
      <section>
        <Video
          src={
            "https://www.marchouben.nl/video/tino-martin-gin-dutch-dat-ik-je-zo-zou-missen.mp4"
          }
          width={500}
          type={"video/mp4"}
        />
      </section>
    </Fragment>
  );
}

export default App;
